
import MobileSelect from 'mobile-select';
import { useRef, useState } from 'react';
interface Props {
  onChange: (v: string[]) => void;
  option: any[];
  placeholder?: string;
  value: string | number | undefined | null;
  onlyValue?: boolean;
  onlyLabel?: boolean;
}

export default function Select({ onChange, option, placeholder, onlyValue = false, onlyLabel= false }: Props) {
  const pickerRef = useRef<MobileSelect | null>(null);
  const [select, setSelect] = useState(false);

  function handleSelectRef(v: any) {
    if (pickerRef.current) return;
    pickerRef.current = new MobileSelect({
      trigger: '#m-select',
      title: `${placeholder}选择`,
      wheels: [{ data: option }],
      keyMap: { id: 'value', value: 'label', childs: 'children' },
      onChange: (cur: any) => {
        if (!select) {
          setSelect(true);
        }
        if (onlyValue) {
          onChange(cur.map((item:any)=>item.value));
        } else if (onlyLabel) {
          onChange(cur.map((item:any)=>item.label));
        } else {
          onChange(cur);
        }

      },
    });
  }
  return (
    <div id="m-select" className={`m_city_picker ${select ? '' : 'place-holder'}`} ref={(v) => handleSelectRef(v)}>
      {placeholder ? `请选择${placeholder}` : '请选择'}
    </div>
  );
}
